import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExpand: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconExpand"><Path d="M12 13V22H2V13H12Z" fill="currentColor"/><Path d="M22 3V16H14V14.5H20.5V4.5H4.5V11H3V3H22Z" fill="currentColor"/><Path d="M18 7V11.5H16.5V9.56066L14 12.0607L12.9393 11L15.4393 8.5H13.5V7H18Z" fill="currentColor"/></CentralIconBase>;
});

export default IconExpand;
